export const LeadAccountFieldsForRules = {
    leadTypesName: 'leadTypesName',
    stageName: 'currentStage',
    leadsStatus: 'leadsStatus',
    sourceName: 'sourceName',
    accountTypesName: 'accountTypesName',
    employeesRangeName: 'employeesRangeName',
    annualRevenueName: 'annualRevenueName',
    ownershipName: 'ownershipName',
    classificatioName: 'currentStage',
    industryName: 'industryName',
    tags: 'tags',
    // timezoneName: 'timezoneName',
    country: 'country',
    state: 'state',
    city: 'city',
    zipcode: 'zipcode'
}

export const QuestionnaireFieldsForRules = {
    leadTypesName: 'leadTypesName',
    stageName: 'currentStage',
    leadsStatus: 'leadsStatus',
    sourceName: 'sourceName',
    accountTypesName: 'accountTypesName',
    employeesRangeName: 'employeesRangeName',
    annualRevenueName: 'annualRevenueName',
    ownershipName: 'ownershipName',
    classificatioName: 'currentStage',
    industryName: 'industryName',
    tags: 'tags',
    // timezoneName: 'timezoneName',
    country: 'country',
    state: 'state',
    city: 'city',
    zipcode: 'zipcode',
    territory: 'territory',
    routes: 'routes'
}

export const QuestionnaireStaticRules = [
    {
        "id": 1008456,
        "name": "Territory",
        "labelName": "Territory",
        "field": "territory",
        "columnName": "territory",
        "isRequired": true,
        "formControl": "DropDownList",
        "formControlId": 1,
        "mapObject": null,
        "enabledInForm": false,
        "isDateWithTime": false,
        "childFields": []
    },
    {
        "id": 1008457,
        "name": "Route(s)",
        "labelName": "Route(s)",
        "field": "routes",
        "columnName": "routes",
        "isRequired": false,
        "formControl": "DropDownList",
        "formControlId": 1,
        "mapObject": null,
        "enabledInForm": false,
        "isDateWithTime": false,
        "childFields": []
      }
]
